module.exports = __webpack_public_path__ + "static/media/itv.92d36493.svg";